import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgThumbLikeFill = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "thumb like 5",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M17.5583 9.56836H15.542C15.1954 9.56836 14.9609 9.17558 15.0742 8.84803C15.7645 6.85099 15.9611 2.76601 12.6138 2.70027C12.5609 2.69923 12.5057 2.70862 12.4567 2.72862C11.9534 2.93414 11.8273 3.18932 11.7214 3.68708C11.0468 6.72838 9.57635 8.40554 8.23769 9.06761C8.16418 9.10397 8.14487 9.19539 8.18155 9.26875C8.60322 10.0455 8.60322 10.8001 8.60322 12.054V18.2127C8.60322 18.7846 8.60322 19.255 8.56096 19.6714C8.5406 19.8721 8.64181 20.0699 8.8259 20.1522C9.76411 20.572 10.7428 20.9314 11.7214 20.9314H16.6706C19.5224 20.9314 21.4976 19.0783 21.4976 16.0156C21.4976 12.8086 21.7307 9.56836 17.5583 9.56836Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.77354 9.2018C5.42399 9.0409 4.25994 9.00983 3.21685 9.00317C2.8207 9.00095 2.5 9.32276 2.5 9.7178V20.5849C2.5 20.981 2.8207 21.3017 3.21685 21.2995C4.25994 21.2939 5.42399 21.2629 5.77354 21.1008C6.18412 20.9122 6.51702 20.6126 6.71676 20.2353C6.9387 19.8358 6.9387 19.3032 6.9387 18.249V12.0537C6.9387 10.9995 6.9387 10.4668 6.71676 10.0674C6.51702 9.69006 6.18412 9.39045 5.77354 9.2018Z",
		fill: "currentColor"
	})]
});
export default SvgThumbLikeFill;
